(() => {
  const DATA_SELECTOR =
    ".cro-product-labels-data";

  const ROOT_SELECTOR =
    ".cro-product-labels-root";

  const STACK_CLASS =
    "cro-product-labels-stack";

  const TARGET_CLASS =
    "cro-product-labels-target";

  const CARD_SELECTORS = [
    "product-card",
    ".card-wrapper",
    ".card",
    ".product-card",
    ".product-item",
    ".grid__item",
    "article",
    "li"
  ];

  const MEDIA_SELECTORS = [
    ".card__inner",
    ".card__media",
    ".media",
    ".product-card__image-wrapper",
    ".product-card__image",
    ".product-item__image-wrapper",
    ".product-item__image",
    "[class*='product-image']",
    "[class*='card-image']"
  ];

  const PRODUCT_MEDIA_SELECTORS = [
    ".product__media-item:first-child .product__media",
    ".product__media-item:first-child",
    ".product-media-container:first-child",
    ".product__media:first-child",
    "[data-product-media]:first-child",
    ".product-gallery__media:first-child",
    ".product-gallery img:first-of-type",
    ".product__media-list img:first-of-type"
  ];


  function getPageType() {
    return (
      document.querySelector(
        ROOT_SELECTOR
      )?.dataset.pageType ||
      ""
    );
  }


  function visibleOnPage(
    label,
    pageType
  ) {
    if (
      pageType === "product"
    ) {
      return (
        label.showOnProduct !==
        false
      );
    }

    if (
      pageType === "collection"
    ) {
      return (
        label.showOnCollection !==
        false
      );
    }

    if (
      pageType === "index"
    ) {
      return (
        label.showOnHomepage !==
        false
      );
    }

    return false;
  }


  function parseProductHandle(
    href
  ) {
    if (!href) {
      return "";
    }

    try {
      const url =
        new URL(
          href,
          window.location.origin
        );

      const match =
        url.pathname.match(
          /\/products\/([^/?#]+)/
        );

      return match
        ? decodeURIComponent(
            match[1]
          )
        : "";
    } catch {
      return "";
    }
  }


  function labelKey(label) {
    if (label?.id) {
      return `id:${label.id}`;
    }

    return [
      "legacy",
      String(
        label?.text || ""
      ).trim(),
      String(
        label?.position || ""
      ),
      String(
        label?.backgroundColor || ""
      ),
      String(
        label?.textColor || ""
      )
    ].join(":");
  }


  function mergeConfigs(
    current,
    incoming
  ) {
    const mergedLabels = [];
    const seen = new Set();

    const allLabels = [
      ...(
        Array.isArray(
          current?.labels
        )
          ? current.labels
          : []
      ),
      ...(
        Array.isArray(
          incoming?.labels
        )
          ? incoming.labels
          : []
      )
    ];

    for (
      const label
      of allLabels
    ) {
      if (
        !label ||
        !label.text
      ) {
        continue;
      }

      const key =
        labelKey(label);

      if (
        seen.has(key)
      ) {
        continue;
      }

      seen.add(key);
      mergedLabels.push(label);
    }

    return {
      active: true,
      labels: mergedLabels
    };
  }


  function loadConfigs() {
    const map =
      new Map();

    document
      .querySelectorAll(
        DATA_SELECTOR
      )
      .forEach(
        (node) => {
          const handle =
            node.dataset
              .productHandle;

          if (!handle) {
            return;
          }

          try {
            const config =
              JSON.parse(
                node.textContent ||
                "{}"
              );

            if (
              !config ||
              !config.active ||
              !Array.isArray(
                config.labels
              ) ||
              !config.labels.length
            ) {
              return;
            }

            map.set(
              handle,
              mergeConfigs(
                map.get(handle),
                config
              )
            );
          } catch {
            // Ignore invalid JSON.
          }
        }
      );

    return map;
  }

  function isInsideOtherCroFeature(element) {
    let node = element;

    while (
      node &&
      node !== document.body
    ) {
      if (
        node instanceof HTMLElement
      ) {
        const id =
          String(
            node.id || ""
          ).toLowerCase();

        const classes =
          Array.from(
            node.classList || []
          ).map(
            (className) =>
              String(
                className
              ).toLowerCase()
          );

        const hasOtherCroClass =
          classes.some(
            (className) =>
              className.startsWith(
                "cro-"
              ) &&
              !className.startsWith(
                "cro-product-labels"
              )
          );

        const hasOtherCroId =
          id.startsWith("cro-") &&
          !id.startsWith(
            "cro-product-labels"
          );

        const hasOtherCroData =
          Array.from(
            node.attributes || []
          ).some(
            (attribute) => {
              const name =
                String(
                  attribute.name || ""
                ).toLowerCase();

              return (
                name.startsWith(
                  "data-cro-"
                ) &&
                !name.startsWith(
                  "data-cro-product-labels"
                )
              );
            }
          );

        if (
          hasOtherCroClass ||
          hasOtherCroId ||
          hasOtherCroData
        ) {
          return true;
        }
      }

      node =
        node.parentElement;
    }

    return false;
  }


  function findCardMedia(
    anchor
  ) {
    let card = null;

    for (
      const selector
      of CARD_SELECTORS
    ) {
      card =
        anchor.closest(
          selector
        );

      if (card) {
        break;
      }
    }

    if (!card) {
      return null;
    }

    for (
      const selector
      of MEDIA_SELECTORS
    ) {
      const media =
        card.querySelector(
          selector
        );

      if (
        media &&
        (
          media.querySelector("img") ||
          media.tagName ===
            "IMG"
        )
      ) {
        return media;
      }
    }

    const image =
      card.querySelector(
        "img"
      );

    return (
      image?.parentElement ||
      null
    );
  }


  function getStack(
    target,
    position
  ) {
    let stack =
      target.querySelector(
        `:scope > .${STACK_CLASS}--${position}`
      );

    if (!stack) {
      stack =
        document.createElement(
          "div"
        );

      stack.className =
        `${STACK_CLASS} ` +
        `${STACK_CLASS}--${position}`;

      target.appendChild(
        stack
      );
    }

    return stack;
  }


  function renderLabels(
    target,
    config,
    pageType
  ) {
    if (!target) {
      return;
    }

    const labels =
      Array.isArray(
        config?.labels
      )
        ? config.labels.filter(
            (label) =>
              visibleOnPage(
                label,
                pageType
              )
          )
        : [];

    if (!labels.length) {
      return;
    }

    if (
      target.dataset
        .croProductLabelsRendered ===
        pageType
    ) {
      return;
    }

    target
      .querySelectorAll(
        `:scope > .${STACK_CLASS}`
      )
      .forEach(
        (node) =>
          node.remove()
      );

    target.classList.add(
      TARGET_CLASS
    );

    for (
      const label
      of labels
    ) {
      if (!label?.text) {
        continue;
      }

      const position =
        [
          "top-left",
          "top-right",
          "bottom-left",
          "bottom-right"
        ].includes(
          label.position
        )
          ? label.position
          : "top-left";

      const stack =
        getStack(
          target,
          position
        );

      const badge =
        document.createElement(
          "span"
        );

      badge.className =
        "cro-product-labels-badge";

      badge.textContent =
        label.text;

      badge.style.backgroundColor =
        label.backgroundColor ||
        "#111827";

      badge.style.color =
        label.textColor ||
        "#ffffff";

      badge.style.fontSize =
        `${Number(
          label.fontSize ||
          12
        )}px`;

      badge.style.fontWeight =
        String(
          label.fontWeight ||
          700
        );

      if (
        label.useThemeFont ===
        false
      ) {
        badge.style.fontFamily =
          label.fontFamily ||
          "Arial";
      } else {
        badge.style.fontFamily =
          "inherit";
      }

      badge.style.borderRadius =
        `${Number(
          label.borderRadius ||
          6
        )}px`;

      badge.style.padding =
        `${Number(
          label.paddingVertical ||
          6
        )}px ` +
        `${Number(
          label.paddingHorizontal ||
          10
        )}px`;

      stack.appendChild(
        badge
      );
    }

    target.dataset
      .croProductLabelsRendered =
        pageType;
  }


  function renderCollectionCards(
    configs,
    pageType
  ) {
    document
      .querySelectorAll(
        'a[href*="/products/"]'
      )
      .forEach(
        (anchor) => {
          const handle =
            parseProductHandle(
              anchor.href
            );

          if (
            !handle ||
            !configs.has(
              handle
            )
          ) {
            return;
          }

          const target =
            findCardMedia(
              anchor
            );

          if (!target) {
            return;
          }

          if (
            isInsideOtherCroFeature(
              target
            )
          ) {
            return;
          }

          renderLabels(
            target,
            configs.get(
              handle
            ),
            pageType
          );
        }
      );
  }


  function createProductImageOverlay(
    image
  ) {
    const parent =
      image?.parentElement;

    if (!parent) {
      return null;
    }

    const parentStyle =
      window.getComputedStyle(
        parent
      );

    if (
      parentStyle.position ===
      "static"
    ) {
      parent.style.position =
        "relative";
    }

    let overlay =
      parent.querySelector(
        ":scope > .cro-product-labels-image-overlay"
      );

    if (!overlay) {
      overlay =
        document.createElement(
          "div"
        );

      overlay.className =
        "cro-product-labels-image-overlay cro-product-labels-target";

      overlay.dataset
        .croProductImageOverlay =
          "true";

      parent.appendChild(
        overlay
      );
    }

    const imageRect =
      image.getBoundingClientRect();

    const parentRect =
      parent.getBoundingClientRect();

    const left =
      imageRect.left -
      parentRect.left +
      parent.scrollLeft;

    const top =
      imageRect.top -
      parentRect.top +
      parent.scrollTop;

    overlay.style.position =
      "absolute";

    overlay.style.left =
      `${left}px`;

    overlay.style.top =
      `${top}px`;

    overlay.style.width =
      `${imageRect.width}px`;

    overlay.style.height =
      `${imageRect.height}px`;

    overlay.style.right =
      "auto";

    overlay.style.bottom =
      "auto";

    overlay.style.margin =
      "0";

    overlay.style.padding =
      "0";

    overlay.style.pointerEvents =
      "none";

    overlay.style.zIndex =
      "20";

    return overlay;
  }


  function findMainProductImageTarget() {
    const selectors = [
      ".product__media-item:first-child .product__media img",
      ".product__media-item:first-child .media img",
      ".product__media-item:first-child img",
      ".product-media-container:first-child img",
      ".product__media:first-child img",
      ".product-gallery__media:first-child img",
      "[data-product-media]:first-child img",
      ".product__media-wrapper img",
      ".product__media-list img",
      ".product-gallery img"
    ];

    for (
      const selector
      of selectors
    ) {
      const images =
        document.querySelectorAll(
          selector
        );

      for (
        const image
        of images
      ) {
        if (
          !image ||
          isInsideOtherCroFeature(
            image
          )
        ) {
          continue;
        }

        const rect =
          image.getBoundingClientRect();

        /*
         * Ignore thumbnails, icons and hidden images.
         */
        if (
          rect.width < 100 ||
          rect.height < 100
        ) {
          continue;
        }

        if (
          !image.complete
        ) {
          image.addEventListener(
            "load",
            queueRender,
            {
              once: true
            }
          );
        }

        return createProductImageOverlay(
          image
        );
      }
    }

    return null;
  }

  function renderProductPage(
    configs,
    pageType
  ) {
    if (
      pageType !==
      "product"
    ) {
      return;
    }

    const root =
      document.querySelector(
        `${ROOT_SELECTOR}[data-current-product-handle]`
      );

    const handle =
      root?.dataset
        .currentProductHandle;

    if (
      !handle ||
      !configs.has(
        handle
      )
    ) {
      return;
    }

    const target =
      findMainProductImageTarget();

    if (!target) {
      return;
    }

    renderLabels(
      target,
      configs.get(
        handle
      ),
      pageType
    );
  }


  function render() {
    const pageType =
      getPageType();

    if (
      ![
        "index",
        "product",
        "collection"
      ].includes(
        pageType
      )
    ) {
      return;
    }

    const configs =
      loadConfigs();

    if (!configs.size) {
      return;
    }

    renderProductPage(
      configs,
      pageType
    );

    if (
      pageType === "index" ||
      pageType === "collection"
    ) {
      renderCollectionCards(
        configs,
        pageType
      );
    }
  }


  let timer = null;

  function queueRender() {
    clearTimeout(
      timer
    );

    timer =
      setTimeout(
        render,
        80
      );
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      render,
      {
        once: true
      }
    );
  } else {
    render();
  }


  const observer =
    new MutationObserver(
      queueRender
    );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    "shopify:section:load",
    queueRender
  );

  window.addEventListener(
    "resize",
    queueRender
  );
})();
